/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { ComplexDependencies } from './dependenciesComplexClass.generated';
import { FractionDependencies } from './dependenciesFractionClass.generated';
import { absDependencies } from './dependenciesAbs.generated';
import { addScalarDependencies } from './dependenciesAddScalar.generated';
import { divideScalarDependencies } from './dependenciesDivideScalar.generated';
import { equalDependencies } from './dependenciesEqual.generated';
import { fixDependencies } from './dependenciesFix.generated';
import { formatDependencies } from './dependenciesFormat.generated';
import { isNumericDependencies } from './dependenciesIsNumeric.generated';
import { multiplyScalarDependencies } from './dependenciesMultiplyScalar.generated';
import { numberDependencies } from './dependenciesNumber.generated';
import { powDependencies } from './dependenciesPow.generated';
import { roundDependencies } from './dependenciesRound.generated';
import { subtractDependencies } from './dependenciesSubtract.generated';
import { createUnitClass } from '../../factoriesAny.js';
export var UnitDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  ComplexDependencies: ComplexDependencies,
  FractionDependencies: FractionDependencies,
  absDependencies: absDependencies,
  addScalarDependencies: addScalarDependencies,
  divideScalarDependencies: divideScalarDependencies,
  equalDependencies: equalDependencies,
  fixDependencies: fixDependencies,
  formatDependencies: formatDependencies,
  isNumericDependencies: isNumericDependencies,
  multiplyScalarDependencies: multiplyScalarDependencies,
  numberDependencies: numberDependencies,
  powDependencies: powDependencies,
  roundDependencies: roundDependencies,
  subtractDependencies: subtractDependencies,
  createUnitClass: createUnitClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesUnitClass.generated.js
// module id = 14
// module chunks = 0